import React, { useEffect, useState } from 'react';

function DeletedCustomersList() {
  const [deletedCustomers, setDeletedCustomers] = useState([]);

  // Fetch deleted customers on mount
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/customers?showDeleted=true`)
      .then((res) => res.json())
      .then((data) => setDeletedCustomers(data))
      .catch((err) => console.error('Failed to fetch deleted customers:', err));
  }, []);

  const handleUndelete = (customerId) => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/customers/${customerId}/undelete`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to undelete customer');
        }
        return res.json();
      })
      .then(() => {
        alert('Customer undeleted successfully');
        // Refresh the list of deleted customers
        return fetch(`${process.env.REACT_APP_BACKEND_URL}/api/customers?showDeleted=true`);
      })
      .then((res) => res.json())
      .then((data) => setDeletedCustomers(data))
      .catch((err) => {
        console.error(err);
        alert('Error undeleting customer.');
      });
  };

  return (
    <div>
      <h2>Deleted Customers</h2>
      {deletedCustomers.length === 0 ? (
        <p>No deleted customers found.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {deletedCustomers.map((cust) => (
            <li key={cust.CustomerID} style={{ margin: '8px 0' }}>
              {cust.CompanyName} ({cust.TenantID}) - Deleted
              <button
                style={{ marginLeft: '10px' }}
                onClick={() => handleUndelete(cust.CustomerID)}
              >
                Undelete
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default DeletedCustomersList;
